import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/fy.ts
var add = "Foeg ta";
var remove = "Ferwider";
var removeAll = "Ferwider alles";
var incomplete = "Sorry, net alle fjilden binne korrekt ynfolle.";
var submit = "Ferstjoere";
var noFiles = "Gjin bestân keazen";
var moveUp = "Gean omheech";
var moveDown = "Nei ûnderen";
var isLoading = "Lade…";
var loadMore = "Mear lade";
var next = "Folgende";
var prev = "Foarige";
var addAllValues = "Foegje alle wearden ta";
var addSelectedValues = "Foegje selektearre wearden ta";
var removeAllValues = "Fuortsmite alle wearden";
var removeSelectedValues = "Fuortsmite selektearre wearden";
var chooseDate = "Kies datum";
var changeDate = "Feroarje datum";
var accepted = function({
  name
}) {
  return `Akseptearje de ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} moat nei ${date(args[0])} wêze.`;
  }
  return `${sentence(name)} moat yn de takomst lizze.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} mei allinne alfabetyske tekens befetsje.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} mei allinne letters en sifers befetsje.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} mei allinne letters en spaasjes befetsje.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} must contain alphabetical characters.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} must contain letters and numbers.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} must contain letters and spaces.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} must contain symbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} must contain uppercase.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} must contain lowercase.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} must contain number.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} can only contain symbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} can only contain uppercase.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} can only contain lowercase.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} moat foar ${date(args[0])} falle.`;
  }
  return `${sentence(name)} moat yn it ferline wêze.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Dit fjild is ferkeard konfigurearre en kin net ferstjoerd wurde.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} moat tusken ${a} en ${b} lizze.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} komt net oerien.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} is gjin jildige datum, brûk de notaasje ${args[0]}`;
  }
  return "Dit fjild is ferkeard konfigurearre en kin net ferstjoerd wurde";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} moat tusken ${date(args[0])} en ${date(args[1])} lizze`;
};
var email = "Folje in jildich e-mailadres yn.";
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} einiget net mei ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} is gjin tastiene wearde.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} moat minimaal ien teken wêze.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} moat lytser wêze as of gelyk wêze oan ${max2} tekens.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} moat ${max2} tekens lang wêze.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} moat grutter wêze as of gelyk wêze oan ${min2} tekens.`;
  }
  return `${sentence(name)} moat tusken de ${min2} en ${max2} tekens befetsje.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} is gjin tastiene wearde.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Mei net mear as ${args[0]} ${name} hawwe.`;
  }
  return `${sentence(name)} moat lytser wêze as of gelyk wêze oan ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Gjin bestânsnotaasjes tastien.";
  }
  return `${sentence(name)} moat fan it type: ${args[0]} wêze`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Mei net minder as ${args[0]} ${name} hawwe.`;
  }
  return `${sentence(name)} moat minimaal ${args[0]} wêze.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `"${value}" is gjin tastiene ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} moat in getal wêze.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" of ")} is ferplichte.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} is ferplicht.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} begjint net mei ${list(args)}.`;
};
var url = function() {
  return `Doch der in jildige url by.`;
};
var invalidDate = "De selektearre datum is ûnjildich.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var fy_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, fy_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=fy.mjs.map